// Gestion du token JWT côté frontend

export function setToken(token) {
  localStorage.setItem('jwt', token);
}

export function getToken() {
  return localStorage.getItem('jwt');
}

export function removeToken() {
  localStorage.removeItem('jwt');
}

export function decodeToken(token) {
  if (!token) return null;
  try {
    // Vérifier que le token a le bon format (3 parties séparées par des points)
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.warn('Token invalide: format incorrect (doit avoir 3 parties)');
      return null;
    }
    
    const payload = parts[1];
    // Ajouter le padding si nécessaire pour base64
    let base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padding = 4 - (base64.length % 4);
    if (padding !== 4) {
      base64 += '='.repeat(padding);
    }
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error('Erreur décodage token:', error);
    return null;
  }
}

export function isTokenExpired(token) {
  if (!token) return true;
  const payload = decodeToken(token);
  if (!payload || !payload.exp) {
    console.warn('Token invalide ou sans expiration:', payload);
    return true;
  }
  const isExpired = Date.now() / 1000 > payload.exp;
  if (isExpired) {
    console.warn('Token expiré. Exp:', new Date(payload.exp * 1000), 'Now:', new Date());
  }
  return isExpired;
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) {
    return false;
  }
  
  // Vérifier que le token peut être décodé
  const payload = decodeToken(token);
  if (!payload) {
    // Supprimer le token invalide
    removeToken();
    return false;
  }
  
  // Vérifier que le token n'est pas expiré
  const isValid = !isTokenExpired(token);
  if (!isValid) {
    // Supprimer le token expiré
    removeToken();
  }
  return isValid;
} 